import React, {useState} from "react";
import styled from "styled-components";
import {observer} from "mobx-react";
import {KeyboardDateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import DateTimeInput from "./DateTimeInput";

export const DepartureOptionInput = observer((props) => {

    return (
        <Styled className={props.className}>
            <label htmlFor={props.id}>{props.label}</label>
            <input  id={props.id} value={props.value} onChange={props.onChange} type="text"/>
        </Styled>
    )
})


const Styled = styled.div`

  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;

  label {
    margin-bottom: 5px;
  }

  input {
    height: 56px;
    width: 100%;
    background: white;
    border: 1px solid #BCE0FD;
    border-radius: 5px ;
    outline: none;
    padding-left: 15px;
    font-weight: normal;
    font-size: 16px;
  }
`


export default DepartureOptionInput
